import React, { useEffect, useState } from "react";
import { Search } from "../../assets/svg";
import { useDebounce } from "../micro";

const DebounceSearch = ({
  search,
  handleChange,
  add2Chardelay = true,
  placeholder = "Search...",
  className = "",
}) => {
  const [searchLocal, setSearchLocal] = useState("");
  const debounceSearch = useDebounce(searchLocal);

  const handleSearch = (e) => {
    setSearchLocal(e?.target?.value || "");
  };

  useEffect(() => {
    if (
      (add2Chardelay &&
        (debounceSearch?.length === 0 || debounceSearch?.length > 1)) ||
      !add2Chardelay
    ) {
      handleChange(debounceSearch || "");
    }
  }, [debounceSearch, add2Chardelay]);

  useEffect(() => {
    setSearchLocal(search);
  }, [search]);

  return (
    <div className={`relative w-full ${className || "max-w-52"}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2" />
      <input
        type="search"
        value={searchLocal}
        onChange={handleSearch}
        placeholder={placeholder}
        className="w-full rounded border border-Grey bg-white py-2 pl-10 pr-4 focus:outline-none"
      />
    </div>
  );
};

export default DebounceSearch;
